module.exports = __webpack_public_path__ + "img/Zambia.dd9dbd96.svg";